export default {
    actionUndo: {
        message: "Se hai fatto clic per errore, fai clic sul link sottostante per ripristinare.",
        undo: "Fare clic per annullare"
    }
}